import { useCallback, useEffect, useState } from "react";
import { ContainerBenefit, ContainerTab, IconButtonPromo, TabHeaderRow, EmptyState, ListItemCard } from "../styles"
import api from "../../../../services/api";
import { CustomButton } from "../../../../components/CustomButton";
import EditarCadastrarBeneficiosPromo from "./EditarCadastrar";
import { FaEdit, FaTrash, FaGift } from "react-icons/fa";
import DeletarBeneficiosPromo from "./Delete";

const BeneficiosPromocao = ({ promo, products }) => {
  const [benefits, setBenefits] = useState([]);
  const [benefit, setBenefit] = useState(null);
  const [modalCreate, setModalCreate] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);

  const endpoint = promo?.Tipo === 'DESCONTO_TAMANHO'
    ? 'promocao-beneficio-tamanho'
    : 'promocao-beneficio';

  const loadBenefits = useCallback(async () => {
    await api.get(`${endpoint}/listar/${promo.Id}`)
    .then(response => setBenefits(response.data))
    .catch(error => console.log('Erro ao listar beneficios ' + error))
  },[promo?.Id, endpoint]);

  useEffect(() => {
    if(promo){
      loadBenefits();
    }
  },[loadBenefits, promo]);

  return (
    <>
      <ContainerTab>
        <TabHeaderRow>
          <h3>O que o cliente ganha?</h3>
          <CustomButton
            appearance="primary"
            onClick={() => {
              setBenefit(null)
              setModalCreate(true);
            }}>
            Adicionar Prêmio
          </CustomButton>
        </TabHeaderRow>

        <ContainerBenefit>
          {benefits.length === 0 ? (
            <EmptyState>
              <FaGift size={24} color="#cbd5e1" />
              <p>Nenhum benefício configurado.</p>
              <span style={{ fontSize: 12 }}>Configure qual produto ou desconto o cliente vai ganhar ao cumprir as regras.</span>
              <CustomButton appearance="ghost" onClick={() => { setBenefit(null); setModalCreate(true); }}>
                Configurar Prêmio
              </CustomButton>
            </EmptyState>
          ) : (
            benefits.map(item => (
              <ListItemCard key={item.Id}>
                <div className="info-group">
                  <span className="title">{item.DescricaoProduto}</span>
                  <span className="subtitle">
                    <b>Benefício:</b> {item.TipoDesconto?.replace('_', ' ')}
                    <span style={{ margin: '0 4px' }}>|</span>
                    {promo?.Tipo === 'DESCONTO_TAMANHO' ? (
                      <>
                        <b>Desconto:</b>{' '}
                        {item.TipoDesconto === 'PERCENTUAL'
                          ? `${item.ValorDesconto}%`
                          : `R$ ${Number(item.ValorDesconto).toFixed(2)}`}
                      </>
                    ) : (
                      <>
                        <b>Qtd liberada:</b> {item.Quantidade}
                        {item.TipoDesconto && item.ValorDesconto > 0 && (
                          <>
                            <span style={{ margin: '0 4px' }}>|</span>
                            <b>Desconto:</b>{' '}
                            {item.TipoDesconto === 'PERCENTUAL'
                              ? `${item.ValorDesconto}%`
                              : `R$ ${Number(item.ValorDesconto).toFixed(2)}`}
                          </>
                        )}
                      </>
                    )}
                  </span>
                </div>
                <div className="actions">
                  <IconButtonPromo onClick={() => { setBenefit(item); setModalCreate(true) }}>
                    <FaEdit size={16} color="#64748b" />
                  </IconButtonPromo>
                  <IconButtonPromo onClick={() => { setBenefit(item); setModalDelete(true) }}>
                    <FaTrash size={16} color="#ef4444"/>
                  </IconButtonPromo>
                </div>
              </ListItemCard>
            ))
          )}
        </ContainerBenefit>
      </ContainerTab>

      {modalCreate &&
        <EditarCadastrarBeneficiosPromo
          open={modalCreate}
          handleClose={() => setModalCreate(false)}
          benefit={benefit}
          products={products}
          promo={promo}
          setBenefits={setBenefits}
      />}
      {modalDelete &&
        <DeletarBeneficiosPromo
          open={modalDelete}
          handleClose={() => setModalDelete(false)}
          benefit={benefit}
          setBenefit={setBenefit}
          setBenefits={setBenefits}
        />}
    </>
  )
}

export default BeneficiosPromocao;
